import {
    FormField
} from "@maysoft/common-component-react"
import {
    Stack,
    Typography,
    IconButton,
    Button,
    Paper
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from "@mui/icons-material/Add"
import Strings from "constants/strings"

type Item = {
    id: string
    key: string
    value: string
}

type ConfigType = {
    notification: Item[]
    email: Item[]
    sms: Item[]
}

type Props = {
    value: ConfigType
    onChange: (val: ConfigType) => void
}

const TemplateConfigForm = ({ value, onChange }: Props) => {

    const handleChange = (
        section: keyof ConfigType,
        id: string,
        field: "key" | "value",
        val: string
    ) => {
        onChange({
            ...value,
            [section]: value[section].map((item) =>
                item.id === id
                    ? { ...item, [field]: val }
                    : item
            )
        })
    }

    const handleRemove = (
        section: keyof ConfigType,
        id: string
    ) => {
        onChange({
            ...value,
            [section]: value[section].filter(
                (item) => item.id !== id
            )
        })
    }

    const handleAdd = (section: keyof ConfigType) => {
        onChange({
            ...value,
            [section]: [
                ...value[section],
                {
                    id: `${Date.now()}_${Math.random()}`,
                    key: "",
                    value: ""
                }
            ]
        })
    }

    const renderSection = (
        section: keyof ConfigType,
        title: string
    ) => {
        const data = value[section]

        return (
            <Paper sx={{ p: 2, borderRadius: 2 }}>
                <Stack spacing={2}>
                    <Stack direction="row" justifyContent="space-between">
                        <Typography fontWeight={600}>
                            {title}
                        </Typography>

                        <Button
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleAdd(section)}
                        >
                            {Strings.Common.ADD}
                        </Button>
                    </Stack>

                    {data && data.map((item) => (
                        <Stack
                            key={item.id}
                            direction="row"
                            spacing={1}
                            alignItems="center"
                        >
                            <FormField
                                label={Strings.SETTING.TEMPLATE_CONFIG.CASE}
                                value={item.key}
                                onChangeValue={(val) =>
                                    handleChange(section, item.id, "key", val)
                                }
                                sx={{ width: "30%" }}
                            />

                            <FormField
                                label={Strings.SETTING.TEMPLATE_CONFIG.DESCRIPTION}
                                value={item.value}
                                onChangeValue={(val) =>
                                    handleChange(section, item.id, "value", val)
                                }
                                fullWidth
                            />

                            <IconButton
                                onClick={() =>
                                    handleRemove(section, item.id)
                                }
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    ))}
                </Stack>
            </Paper>
        )
    }

    return (
        <Stack spacing={3}>
            {renderSection("notification", Strings.SETTING.TEMPLATE_CONFIG.NOTIFY)}
            {renderSection("email", Strings.SETTING.TEMPLATE_CONFIG.EMAIL)}
            {renderSection("sms", Strings.SETTING.TEMPLATE_CONFIG.SMS)}
        </Stack>
    )
}

export default TemplateConfigForm